( function( $ ) {
$(document).ready(function() {
    $('.spotlight-slides ul').bxSlider({
        mode: 'fade',
        pager: false,
        controls: false,
        auto: true
    });

    $('a.gallery-link').featherlightGallery({
        afterContent: function() {
            this.$legend = this.$legend || $('<div class="legend"/>').insertAfter(this.$content);
            this.$legend.html(this.$currentTarget.data('caption'));
            var alt = this.$currentTarget.prop('alt');
            $('.featherlight-content > img').prop('alt', alt );
        }
    });

    $('#toggle-mobile-nav').click(function(e) {
        e.preventDefault();
        $('.main-navigation').toggleClass('open');
        $('body').toggleClass('in-navigation');
    });

    $('#to-top').click(function(e) {
        $('html, body').animate({ scrollTop: 0}, 500 );
    });
});

$(document).scroll(function() {
    if ($(window).scrollTop() > 200)
        $('#to-top').addClass('in-scroll');
    else
        $('#to-top').removeClass('in-scroll');
});

function nocontextmenu()
{
    alert('Deze functie is uitgezet, voor meer informatie neemt u contact met Edelsmid Ton van den Hout b.v. op. Bedankt voor uw begrip.');
    event.cancelBubble = true
    event.returnValue = false;

    return false;
}

function norightclick(e)
{
    if (window.Event)
    {
        if (e.which == 2 || e.which == 3)
        {
            //alert('Deze functie is uitgezet, voor meer informatie neemt u contact met ons op via 0475 - 328 447. Bedankt voor uw begrip.');
            return false;
        }
    }
    else
    if (event.button == 2 || event.button == 3)
    {
        //alert('Deze functie is uitgezet, voor meer informatie neemt u contact met ons op via 0475 - 328 447. Bedankt voor uw begrip.');
        event.cancelBubble = true
        event.returnValue = false;
        return false;
    }
}

document.oncontextmenu = nocontextmenu;
document.onmousedown = norightclick;

} )( jQuery );